module.exports = __webpack_public_path__ + "static/media/Screenshot15.b9b99c45.jpg";